import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { UserInfoIdSchema } from '../user/user.types.js';
import { taggingEntityTypes } from './tag.constants.js';
// ===== ID SCHEMAS =====
const TagIdSchema = createIdSchema('tag');
const TagTableSelectSchema = createStrictSchema()({
    id: TagIdSchema,
    name: z.string(),
    system: z.boolean(),
    creatorId: UserInfoIdSchema.nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
const TaggingTableSelectSchema = createStrictSchema()({
    tagId: TagIdSchema,
    entityId: z.string(), // Generic ID - could be workout plan, movement, etc.
    entityType: z.enum(taggingEntityTypes),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const TagInfoSchema = TagTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API
});
const TaggingInfoSchema = TaggingTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API
});
export { TagInfoSchema, TagTableSelectSchema, TaggingInfoSchema, TaggingTableSelectSchema };
//# sourceMappingURL=tag.types.js.map